export default "__VITE_ASSET__DoDenaa6__"